import { formatMoney, formatQty } from "@/domain/money";

export const amount = (value: number | null, currency: string) =>
  value == null
    ? "—"
    : `${formatMoney(value, currency, { symbol: false })} ${currency}`;
export const quantities = (rows: { unit: string; quantity: number }[]) =>
  rows.map((row) => `${formatQty(row.quantity)} ${row.unit}`).join(" · ") ||
  "—";
export const marginClass = (value: number | null) =>
  value == null
    ? "text-ink-faint"
    : value < 0
      ? "text-danger"
      : value > 0
        ? "text-ok"
        : "text-ink-soft";
